"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BaseComponent_1 = require("./base/BaseComponent");
var ko = require("knockout");
var MobileInputPasswordComponent = (function (_super) {
    __extends(MobileInputPasswordComponent, _super);
    function MobileInputPasswordComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.password = ko.observable().extend({ required: true });
        this.isPasswordVisible = ko.observable();
        this.togglePassword = function () {
            _this.isPasswordVisible(!_this.isPasswordVisible());
        };
        this.getPasswordType = ko.pureComputed(function () {
            return _this.isPasswordVisible() ? "text" : "password";
        });
        this.getToggleIcon = ko.pureComputed(function () {
            return _this.isPasswordVisible() ? "icon-eye-slash" : "icon-eye";
        });
        this.password = params.password;
        this.placeholder = params.placeholder || "Пароль";
        this.name = params.name || "password";
        this.isPasswordVisible = params.isPasswordVisible || ko.observable(false);
        this.disableAutocomplete = params.disableAutocomplete;
        this.autocomplete = params.autocomplete;
    }
    return MobileInputPasswordComponent;
}(BaseComponent_1.default));
;
ko.components.register("mobile-input-password", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MobileInputPasswordComponent;
//# sourceMappingURL=mobileInputPassword.js.map